// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const drawingHistoryTableStyle = theme => ({


})


export default drawingHistoryTableStyle